module.exports = __webpack_public_path__ + "static/img/default.a3b1ec7e.png";